function translationExists(key) {
  return typeof language[key] !== "undefined";
}

function entityTranslate(key) {
  if (language["entity_" + key]) {
    return language["entity_" + key];
  } else if (language["entity_" + key + "s"]) {
    return language["entity_" + key + "s"];
  } else {
    return key;
  }
}

function translate(key) {
  const keyCheck = Array.isArray(key) ? key[0] : key;
  if (translationExists(keyCheck)) {
    return key === keyCheck
      ? language[key]
      : language[key[0]](key[1], entityTranslate(key[2].toLowerCase()));
  } else if (debug === true) {
    showAlertDialog(
      "Language key: " + keyCheck + " does not exist!",
      "dialog_error"
    );
  } else {
    return key;
  }
}
